// Do not edit.
import { ShaderStore } from "core/Engines/shaderStore";
import { atmosphereUboDeclarationWGSL } from "../ShadersWGSL/ShadersInclude/atmosphereUboDeclaration";
import { helperFunctionsWGSL } from "core/ShadersWGSL/ShadersInclude/helperFunctions";
import { intersectionFunctionsWGSL } from "core/ShadersWGSL/ShadersInclude/intersectionFunctions";
import { atmosphereFunctionsWGSL } from "../ShadersWGSL/ShadersInclude/atmosphereFunctions";

const name = "transmittancePixelShader";
const shader = `#define RENDER_TRANSMITTANCE
#define EXCLUDE_RAY_MARCHING_FUNCTIONS
#include<atmosphereUboDeclaration>
#include<helperFunctions>
#include<atmosphereFunctions>
varying vUV: vec2f;@fragment
fn main(input: FragmentInputs)->FragmentOutputs {fragmentOutputs.color=renderTransmittance(input.vUV);}
`;
// Sideeffect
if (!ShaderStore.ShadersStoreWGSL[name]) {
    ShaderStore.ShadersStoreWGSL[name] = shader;
}
const includes = [atmosphereUboDeclarationWGSL, helperFunctionsWGSL, intersectionFunctionsWGSL, atmosphereFunctionsWGSL];
for (const inc of includes) {
    if (!ShaderStore.IncludesShadersStoreWGSL[inc.name]) {
        ShaderStore.IncludesShadersStoreWGSL[inc.name] = inc.shader;
    }
}

/** @internal */
export const transmittancePixelShaderWGSL = { name, shader };
